import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import router from '../../router';
import axios from 'axios';
import { vxm } from '@/store.vuex';
import { UserSkillsWrapper } from './userskillwrapper';
import { CompanySkill } from './companyskills';
import { CompanySkillWrapper } from './companyskillwrapper';
import { DocumentPayload } from './documentpayload';
import { SkillDocWrapper } from './skilldocwrapper';
import { DocumentResponse } from './documentresponse';
import { DropboxSelection } from '../userdata/dropbox';
import { ExpertiseCategoryDataWrapper } from './../expertise/expertisecategorywrapper';
import { JobSkillType } from './JobSkillType';
import { UserAttributeMasterMetadata } from '../skills/UserAttributeMasterMetadata';

declare var window: any;

@Module({ namespacedPath: 'skills/' })
export class SkillStore extends VuexModule {
  private userSkillWrapper: UserSkillsWrapper = new UserSkillsWrapper();
  private companySkills: CompanySkill[] = [];
  private companySkillWrapper: CompanySkillWrapper = new CompanySkillWrapper();
  private skillDocWrapper: SkillDocWrapper[] = [];
  private documentResponse: DocumentResponse = new DocumentResponse();
  private dropBoxRec: any;
  private expertiseWrapper: ExpertiseCategoryDataWrapper = new ExpertiseCategoryDataWrapper();
  private categoryDetais: any = {
    categoryId: 1,
    childCategories: [],
    description: '',
    name: '',
  };
  private credentialList: UserAttributeMasterMetadata[] = [];

  //////////////////////////////////////////////////////////////////////////////////////////

  public get DocResponse(): DocumentResponse {
    return this.documentResponse;
  }

  public get CategoryDetails() {
    return this.categoryDetais;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  public get SkillDocWrapper(): SkillDocWrapper[] {
    return this.skillDocWrapper;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  public get skillWrapper(): UserSkillsWrapper {
    return this.userSkillWrapper;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  public get CompanySkills(): CompanySkill[] {
    return this.companySkills;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  public get CompanySkillWrapper(): CompanySkillWrapper {
    return this.companySkillWrapper;
  }

  public get expertiseDataWrapper(): ExpertiseCategoryDataWrapper {
    return this.expertiseWrapper;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  public get getCredentialList(): UserAttributeMasterMetadata[] {
    return this.credentialList;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setDocResponse(dr: DocumentResponse) {
    this.documentResponse = dr;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setUserSkillDocWrapper(sdw: SkillDocWrapper[]) {
    this.skillDocWrapper = sdw;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setUserSkillWrapper(usw: UserSkillsWrapper) {
    this.userSkillWrapper = usw;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setCompanySkills(cs: CompanySkill[]) {
    this.companySkills = cs;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setCompanySkillWrapper(csw: CompanySkillWrapper) {
    this.companySkillWrapper = csw;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public getUserSkills(token: string) {
    this.getCompanySkillsAndAttachments();
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setCredentialList(credentials: UserAttributeMasterMetadata[]) {
    this.credentialList = credentials;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @mutation
  public setDropBoxRec(drc: any) {
    this.dropBoxRec = drc;
  }

  @mutation
  public setExpertiseWrapper(usw: ExpertiseCategoryDataWrapper) {
    this.expertiseWrapper = usw;
  }

  @mutation
  public setCategoryDetails(payload) {
    this.categoryDetais = payload;
  }

  public get DropBoxRec(): any {
    return this.dropBoxRec;
  }

  @action({ mode: 'mutate' })
  public async activateSkill(skillMapId: number) {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/skill/' + skillMapId,
      null,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    await vxm.users.getUserProfileAndNavigateTo('Skills');
    vxm.users.getSkills();
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async deleteSkill(sMapId: number) {
    const token = 'Bearer ' + vxm.users.getToken;
    // tslint:disable-next-line: max-line-length
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/skill/delete/' + sMapId,
      null,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    await vxm.users.getUserProfileAndNavigateTo('Skills');
    vxm.users.getSkills();
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async deleteSkillApplyFLow(sMapId: number) {
    const token = 'Bearer ' + vxm.users.getToken;
    // tslint:disable-next-line: max-line-length
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/skill/delete/' + sMapId,
      null,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getCompanySkills() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v2/user-profile/skill/companySkills',      
      { 
        params: {
          locale: vxm.utility.langaugeRegionMapping
        },
        headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    this.setCompanySkills(resp.data);
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getUserSkillListing() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get('/wl-profile-svc/api/user-profile/skills', {
      headers: { 'Content-Type': 'application/json', Authorization: token },
    });
    this.setUserSkillDocWrapper(resp.data);
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async uploadApplyFowDocument(payload: DocumentPayload) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const formData = new FormData();
    const expiryDate =
      Number(payload.expiryDate) + 23 * 60 * 60 * 1000 + 59 * 60 * 1000;
    formData.append(payload.uid + '', payload.documentFile);
    formData.append('document', payload.document.documentName);
    formData.append('effectiveDTTM', payload.effectiveDate);
    formData.append('expiryDTTM', expiryDate.toString());
    formData.append('documentId', payload.documentId.toString());
    formData.append('licenseState', payload.licenseState);
    formData.append('licenseNumber', payload.licenseNumber);
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/uploaduserattributes',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: bearerToken,
        },
      },
    );
    vxm.users.updatedUserProfile();
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async uploadSkillDocument(payload: DocumentPayload) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const formData = new FormData();
    const expiryDate = payload.expiryDate
      ? (
        Number(payload.expiryDate) +
        23 * 60 * 60 * 1000 +
        59 * 60 * 1000
      ).toString()
      : '';
    formData.append(payload.uid + '', payload.documentFile);
    formData.append('document', payload.document.documentName);
    formData.append('effectiveDTTM', payload.effectiveDate);
    formData.append('expiryDTTM', expiryDate);
    formData.append('licenseState', payload.licenseState);
    formData.append('licenseNumber', payload.licenseNumber);
    // Validate documentId
    if (payload.documentId) {
      formData.append('documentId', payload.documentId.toString());
    }
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/uploaduserattributes',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: bearerToken,
        },
      },
    );
    await vxm.users.getUserProfileAndNavigateTo('Skills');
    vxm.users.getSkills();
    return resp.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async viewSkillDocument(attributeID: number) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/user-profile/view/userattributeid/' + attributeID,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    this.setDocResponse(resp.data);
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getCompanySkillsAndAttachments() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v2/user-profile/skill/companySkills',
      { 
        params: {
          locale: vxm.utility.langaugeRegionMapping
        },
        headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    this.setCompanySkillWrapper(resp.data);
    // router.push({ name: 'Skills' });
  }

  @action({ mode: 'mutate' })
  public async deleteSkillAttributeApplyFlow(attributeID: number) {
    console.log('deleting skill attribute:' + attributeID);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/user-profile/skill/delete/' + attributeID,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async deleteSkillAttribute(attributeID: number) {
    console.log('deleting skill attribute:' + attributeID);
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/user-profile/skill/delete/' + attributeID,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    await vxm.users.getUserProfileAndNavigateTo('Skills');
    vxm.users.getSkills();
    return resp.data;
  }


  @action({ mode: 'mutate' })
  public async getValidCredentials() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v2/credentialing/valid-credentials',
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    if (resp.data && resp.data.data)
      this.setCredentialList(resp.data.data);
  }

  @action({ mode: 'mutate' })
  public async deleteSkillAttributeDoc(documentResponse: DocumentResponse) {
    console.log(
      'deleting skill attribute:' +
      documentResponse.userAttributeId +
      ' documentId:' +
      documentResponse.documentId,
    );
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/user-profile/skill/deleteUserAttributeDocument/' +
      documentResponse.userAttributeId,
      {
        params: {
          docId: documentResponse.documentId,
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    await vxm.users.getUserProfileAndNavigateTo('Skills');
    vxm.users.getSkills();
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async uploadDropboxAttribute(
    payload: DocumentPayload,
  ): Promise<string> {
    const dbxUploadUrl = '/wl-profile-svc/api/user-profile/uploadFileDropbox';
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    console.log('bearerToken drop box attribute:' + bearerToken);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    };

    return new Promise<string>((resolve, reject) => {
      this.selectFromDropbox([])
        .then((selected) => {
          const file = selected.file;
          if (!!file) {
            const dbxRec = {
              fileLink: file.link,
              userAttributeId: payload.uid,
              documentId: payload.documentId,
            };
            this.setDropBoxRec(dbxRec);
            axios
              .post(dbxUploadUrl, dbxRec, config)
              .then((res) => {
                if (res.data.success) {
                  resolve(selected.status);
                } else {
                  reject('Error importing Dropbox file.');
                }
              })
              .catch((err) => {
                reject(err);
                console.log('ERR:', err);
              });
          } else {
            resolve(selected.status);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  @action({ mode: 'mutate' })
  public selectFromDropbox(extensions: string[]): Promise<DropboxSelection> {
    const options: Dropbox.ChooserOptions = {
      // tslint:disable-next-line:no-empty
      success: (files) => { },

      linkType: 'direct',

      multiselect: false,
      extensions: ['.txt', '.pdf', '.doc', '.docx'],

      folderselect: false,
      sizeLimit: 2097152, // 2MB
    };

    try {
      return new Promise<DropboxSelection>((resolve, reject) => {
        const success = (files: ReadonlyArray<Dropbox.ChooserFile>): void => {
          // tslint:disable-next-line: prefer-for-of
          for (let i = 0; i < files.length; i++) {
            resolve(DropboxSelection.success(files[i]));
            return;
          }
          reject('Error selecting Dropbox file.');
        };
        const cancel = (): void => {
          resolve(DropboxSelection.cancel());
        };
        options.cancel = cancel;
        options.success = success;
        window.Dropbox.choose(options);
      });
    } catch (ex) {
      return Promise.reject(ex);
    }
  }

  @action({ mode: 'mutate' })
  public async uploadDropboxAttributeFile(
    payload: DocumentPayload,
  ): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.selectFromDropbox([])
        .then((selected) => {
          const file = selected.file;
          if (!!file) {
            resolve(file.link);
          } else {
            resolve(selected.status);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  @action({ mode: 'mutate' })
  public async uploadViaDropbox(documentPayload: any) {
    const dbxUploadUrl = '/wl-profile-svc/api/user-profile/uploadFileDropbox';
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    console.log('bearerToken drop box attribute:' + bearerToken);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    };
    const dbxRec = {
      fileLink: documentPayload.documentFile,
      userAttributeId: documentPayload.uid,
      documentId: documentPayload.documentId,
      effectiveDTTM: documentPayload.effectiveDate,
      expiryDTTM: documentPayload.expiryDate,
      licenseState: documentPayload.licenseState,
      licenseNumber: documentPayload.licenseNumber,
    };
    console.log('dbxRec >> ' + dbxRec);

    const resp = await axios.post(dbxUploadUrl, dbxRec, config);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async getCategoryExpertiseData(payload) {
    let resp = await this.fetchExpertiseData(payload);
    // if(payload.searchAllCategories) {
    //   this.setExpertiseWrapper(ex.data);
    //   return ex.data;
    // }
    this.setExpertiseWrapper(resp.data.data);
    return resp.data.data;
    //this.setExpertiseWrapper(categories.data);
    // router.push({ name: 'Skills' });
  }

  @action({ mode: 'mutate' })
  async fetchExpertiseData(payload) {
    if (vxm.users.isLoggedIn) {
      const resp = await axios.post(
        '/wl-lookup-svc/api/v1/wlcategories/fetch',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + vxm.users.getToken,
          },
        },
      );
      return resp;
    } else {
      const resp = await axios.post(
        '/wl-lookup-svc/api/v1/anon/wlcategories/fetch',
        { ...payload, companyCode: vxm.jobs.BrandingInfo.companycode },
      );
      return resp;
    }
  }

  @action({ mode: 'mutate' })
  public async getUserSkillsForJobSkills(jobSkills: string[]) {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      //'https://run.mocky.io/v3/7c96d742-6133-4d2a-8cb3-c6c37b86d781',
      '/wl-profile-svc/api/v1/getUserSkillsForJobSkills/' +
      vxm.jobs.BrandingInfo.companycode,
      jobSkills,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async deleteSkillTypeId(skillTypeId: number) {
    const token = 'Bearer ' + vxm.users.getToken;
    // tslint:disable-next-line: max-line-length
    const resp = await axios.post(
      '/wl-profile-svc/api/user-profile/skill/skillTypeId/' + skillTypeId,
      null,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async fetchCategoryDetails(id) {
    if (vxm.users.isLoggedIn) {
      const response = await axios.get(
        `/wl-lookup-svc/api/v1/wlcategories/${id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + vxm.users.getToken,
          },
        },
      );
      this.setCategoryDetails(response.data.data);
    } else {
      const response = await axios.get(
        `/wl-lookup-svc/api/v1/anon/wlcategories/${id}`,
      );
      this.setCategoryDetails(response.data.data);
    }
  }
}
